export default __webpack_public_path__ + "static/media/arrow-bar-left.fe1ff86d.svg";